import React from 'react'
import Preheader from './Preheader'
import Parters from './Parters'
import Footer from './Footer'
import founder from './image/founderbrij.jpg'
import team1 from './image/t1.jpg'
import team2 from './image/t2.jpg'
import team3 from './image/t31.png'
import team4 from './image/t41.png'
import aboutus from './image/about-us-ndt.jpg'
import { Helmet } from 'react-helmet'
export default function About() {
  return (
   <>

<Helmet>
        <title>
        About NDT - New Delhi Tigers


        </title>
        <meta
          name="title"
          content="About NDT - New Delhi Tigers"
        />
        <meta
          name="keywords"
          content=" 
New Delhi Tigers
Mission Vission of New Delhi Tigers
Delhi Premier League T20
Delhi Premier League T20 Team
New Delhi Tigers Team
"
        />

        <meta
          name="description"
          content="Welcome to New Delhi Tigers, a fierce competitor in the electrifying Delhi Premier League T20. Backed by the vision of our founders, the team stands as a symbol of strength, discipline, and unwavering passion for cricket.

At New Delhi Tigers, we celebrate the unity of talent and the excitement of the game. With every match, we aim to represent the vibrant spirit of Delhi and the timeless love for cricket. Our squad, selected for their exceptional skills and competitive edge, is prepared to dominate the pitch and rise to every occasion.

"
        />

        <link rel="canonical" href="https://newdelhitigers./about" />
      </Helmet>


     <Preheader/>
   <div class="container-fluid p-0">
        <div class="breadcrumb-bg">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                <div className="newheading1">
  <h5>About Us</h5>
  <div className="line"></div>
</div>                </ol>
            </nav>
        </div>
        </div>

        <section className='about--us'>
        <div className='container-fluid'>
            <div className='abou-us'>
              <div className='row'>
               

              <div className='col-md-5 col-12'>
                    <div className='leftimage'>
                        <img src={aboutus} className='img-fluid'/>
                    </div>
                </div>

                <div className='col-md-7 col-12 align-self-center'>
                    <div className='rigthabout'>
                        <h5>New Delhi Tigers</h5>
                       <p>Welcome to New Delhi Tigers, a fierce competitor in the electrifying Delhi Premier League T20. Backed by the vision of our founders, the team stands as a symbol of strength, discipline, and unwavering passion for cricket.
</p>
<p>At New Delhi Tigers, we celebrate the unity of talent and the excitement of the game. With every match, we aim to represent the vibrant spirit of Delhi and the timeless love for cricket. Our squad, selected for their exceptional skills and competitive edge, is prepared to dominate the pitch and rise to every occasion.
</p>
                    </div>
                </div>
              </div>
            </div>
        </div>
        </section>


        <section className='misionbox'>
            <div className='container'>
                <div className='row'>
                    <div className='col-12 col-md-6'>
                        <div className='cardmission'>
                            <h5>Mission</h5>
<p>To build a strong, disciplined, and passionate cricket team that consistently delivers thrilling performances, and promotes a winning culture in the Delhi Premier League T20.
We aim to engage our fans, and contribute to the growth of cricket across Delhi and beyond.
</p>
                        </div>
                    </div>


                    <div className='col-12 col-md-6'>
                        <div className='cardmission'>
                            <h5>Vision</h5>
<p>To become the most respected and successful franchise in DPL T20, representing Delhi’s spirit through excellence, unity, and unwavering commitment to the game of cricket.

</p>
<p></p>
<br></br>
                        </div>
                    </div>
                </div>
            </div>
        </section>

     
        <Parters/>
        <Footer/>
   
   </>
  )
}
